import { useEffect, useState } from "react";

import { isPreviewing, subscribeToEditor } from "@builder.io/sdk-react";

import { useBuilder } from "~/hec/hooks/useBuilder";

/**
 * Subscribes to live edit messages from the Builder editor and overlays the
 * SSR `initialContent` with the latest update. Outside preview mode the hook
 * never subscribes and returns `initialContent` unchanged — no extra render
 * on revalidation.
 */
export function useBuilderPreviewContent<T>({
  initialContent,
  model,
}: {
  initialContent: T;
  model: string;
}): T {
  const apiKey = useBuilder().config.api_key;
  const [previewContent, setPreviewContent] = useState<T | null>(null);

  useEffect(() => {
    if (!isPreviewing()) return;
    const unsubscribe = subscribeToEditor({
      model,
      apiKey,
      callback: updated => setPreviewContent(updated as T),
    });
    return unsubscribe;
  }, [model, apiKey]);

  return previewContent ?? initialContent;
}
